var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKetones(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 511.469 511.469"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#02555B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M415.734 319.469c0 88.366-71.634 160-160 160s-160-71.634-160-160c0-40.96 93.28-184.32 160-276.8 12.32 17.28 32 45.44 53.92 77.6l26.08-17.76c-35.84-53.44-67.2-96-67.52-96-5.243-7.113-15.259-8.63-22.372-3.388a16.005 16.005 0 00-3.388 3.388c-18.72 24.96-178.72 244.48-178.72 312.96 0 106.039 85.961 192 192 192s192-85.961 192-192h-32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.734 319.469c0 61.856 50.144 112 112 112v-32c-44.183 0-80-35.817-80-80h-32zM303.734 223.469h48v48h32v-48h48v-32h-48v-48h-32v48h-48z"
  }))));
}
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAic3RhdGljL2Nzcy8zNTBmNzFkYjY5NGFmNmU2YzI0ZWJlNzg2MWQyZWU0Yy5zdmciOw==";
export { SvgKetones as ReactComponent };